import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';

import { ServiceSlugs, WorkflowId } from '@ply-io/ply-front-shared-utilities';

import Flow from './Flow.vue';
import { InterfaceFocusedFlow } from './InterfaceFocused';
import {
	useFeatureFlagsGetters,
	useTreeBlocksActions,
	useSelectedWorkflowActions,
	useWorkflowVersionsActions,
	useWorkflowGraphsActions,
	useWorkflowsGetters,
	useAppsActions,
	useAppsGetters,
	useSelectedNodeActions,
	useLeftSideDrawerActions,
} from '@/store-composables';
import IntercomService from '@/utils/IntercomService';
import UserbackService from '@/utils/UserbackService';
import ExtensionCommunicationService from '@/utils/extension-communication-service';


export default /*#__PURE__*/_defineComponent({
  __name: 'FlowRouter',
  props: {
    wfID: null,
    isNormalMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { wfID: WorkflowId; isNormalMode: boolean }


const getAuthStoreComposable = () => import('@/store-composables/auth'); // solves circular dependency from router

const getUser = async () => {
	const { user } = (await getAuthStoreComposable()).useAuthGetters();
	return user;
};

onMounted(async () => {
	const user = await getUser();
	ExtensionCommunicationService.notifyExtensionPageCreated();
	const { isInAppHelpEnabled } = useFeatureFlagsGetters();
	const { getServiceDataBySlug, getActionsOfApp } = useAppsActions();
	const { getServiceBySlug } = useAppsGetters();
	if (!isInAppHelpEnabled.value) {
		IntercomService.update({}, false); // we manage pusher connection from here and not from auth, to open a connection only when needed
	}
	UserbackService.init(user.value, 'w'); // This will position it to the right side.
	await Promise.all([getServiceDataBySlug(ServiceSlugs.Branches), getServiceDataBySlug(ServiceSlugs.Loop)]);
	const branchService = getServiceBySlug.value(ServiceSlugs.Branches);
	const loopService = getServiceBySlug.value(ServiceSlugs.Loop);
	if (!branchService || !loopService) {
		throw new Error('Branches or Loop service not found');
	}
	await Promise.all([getActionsOfApp(branchService.id, branchService.version), getActionsOfApp(loopService.id, loopService.version)]);
});
const { removeTempBlock, setMoveStepLocationInTreeInactive } = useTreeBlocksActions();
const { removeWorkflowPusherConnection, selectWorkflowId } = useSelectedWorkflowActions();
const { clearSelectedWorkflowSelectedVersion } = useWorkflowVersionsActions();
const { setIsSelectingWorkflowRoute, setIsRouteSelected } = useWorkflowGraphsActions();
const { isLoadingWorkflowGraph } = useWorkflowsGetters();
const { closeSideBar } = useSelectedNodeActions();
const { clearLeftSideBar } = useLeftSideDrawerActions();
onBeforeUnmount(async () => {
	await closeSideBar({ avoidRedirect: true });
	await clearLeftSideBar();
	const user = await getUser();
	await removeTempBlock();
	await removeWorkflowPusherConnection();
	await clearSelectedWorkflowSelectedVersion();
	setMoveStepLocationInTreeInactive();
	setIsSelectingWorkflowRoute(false);
	setIsRouteSelected(false);
	UserbackService.init(user.value, 'e'); // This will position it back to default east [left]
});

const hasLoadedNodesData = ref(false);
const setHasLoadedNodesData = (v: boolean) => (hasLoadedNodesData.value = v);
watch(
	() => props.wfID,
	async (newWfID) => {
		hasLoadedNodesData.value = false;
		await selectWorkflowId(newWfID);
		hasLoadedNodesData.value = true;
	},
	{ immediate: true }
);

return { __sfc: true,props, getAuthStoreComposable, getUser, removeTempBlock, setMoveStepLocationInTreeInactive, removeWorkflowPusherConnection, selectWorkflowId, clearSelectedWorkflowSelectedVersion, setIsSelectingWorkflowRoute, setIsRouteSelected, isLoadingWorkflowGraph, closeSideBar, clearLeftSideBar, hasLoadedNodesData, setHasLoadedNodesData, Flow, InterfaceFocusedFlow }
}

})